var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPosition = function SvgIconPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.384 6.756a.3.3 0 0 1-.233 0L1.175 4.157a.292.292 0 0 1 0-.534L7.15 1.024a.3.3 0 0 1 .233 0l5.977 2.6a.292.292 0 0 1 0 .533z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m12.299 6.367 1.062.462a.292.292 0 0 1 0 .535L7.384 9.962a.3.3 0 0 1-.233 0L1.175 7.364a.292.292 0 0 1 0-.535l1.061-.462"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m12.299 9.578 1.062.462a.292.292 0 0 1 0 .535l-5.977 2.598a.3.3 0 0 1-.233 0l-5.976-2.598a.292.292 0 0 1 0-.535l1.061-.462"
  })));
};
export default SvgIconPosition;